export default __webpack_public_path__ + "static/media/UiEleveInactive.141e1ce6.svg";